module.exports = "js/webpack/ba9a274b9323753cd95bc3b1eb2f4e5f.gif";